import IconButton from '@mui/material/IconButton'; //added for dropdown action buttons on users table
import Menu from '@mui/material/Menu'; //added for dropdown action buttons on users table
//import MenuItem from '@mui/material/MenuItem'; //commented; duplicate call of MenuItem import on line 18.
import MoreVertIcon from '@mui/icons-material/MoreVert'; //added for dropdown action buttons on users table
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import AnnouncementOverlay from '../components/AnnouncementOverlay';
import GeofenceMap from '../components/GeofenceMap';
import { downloadFile } from '../api/axios';
import AttendanceFilter from '../components/AttendanceFilter';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Box, Typography, Paper, Table, TableBody, TableCell,
  TableHead, TableRow, Button, TextField, Chip, Alert,
  Dialog, DialogTitle, DialogContent, DialogActions,
  Card, CardContent, Select, MenuItem, InputLabel, FormControl,
  CircularProgress
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import PeopleIcon from '@mui/icons-material/People';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Sidebar from '../components/Sidebar';
import api from '../api/axios';

import { SIDEBAR_WIDTH } from '../components/Sidebar';
import { useIsMobile } from '../hooks/useIsMobile';

const STATES = [
  'Abia', 'Adamawa', 'Akwa-Ibom', 'Anambra', 'Bauchi', 'Bayelsa',
  'Benue', 'Cross-River', 'Delta', 'Ebonyi', 'Edo', 'Ekiti', 'Enugu',
  'FCT', 'Gombe', 'Imo', 'Jigawa', 'Kaduna', 'Kano', 'Katsina', 'Kebbi',
  'Kogi', 'Kwara', 'Lagos', 'Nasarawa', 'Niger', 'Ogun', 'Ondo', 'Osun',
  'Oyo', 'Plateau', 'Rivers', 'Sokoto', 'Taraba', 'Yobe', 'Zamfara',
];

const DEPARTMENTS = [
  'HR&A', 'Resource Mobilization and Grant Management',
  'Social Mobilization and Outreach', 'EQAS', 'EVT',
  'OOSC', 'PRS', 'FA', 'IA', 'PROTOCOL',
  'SERVICOM', 'PROCUREMENT', 'LEGAL', 'AE',
];

export default function AdminDashboard() {
  const [resetPwDialog, setResetPwDialog] = useState(false);
  const isMobile = useIsMobile();
  const [bulkUploadDialog, setBulkUploadDialog] = useState(false);
  const [bulkFile, setBulkFile] = useState(null);
  const [bulkLoading, setBulkLoading] = useState(false);
  const [bulkResult, setBulkResult] = useState(null);
  const [stateMappings, setStateMappings] = useState([]);
  const [actionAnchor, setActionAnchor] = useState(null); // newly added for dropdown action buttons
  const [stateForm, setStateForm] = useState({ state: '', geofence_id: '' });
  const [editDialog, setEditDialog] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [earlyClockouts, setEarlyClockouts] = useState([]);
  const [resetPwUser, setResetPwUser] = useState(null);
  const [overrideDialog, setOverrideDialog] = useState(false);
  const [overrideUser, setOverrideUser] = useState(null);
  const [overrideDate, setOverrideDate] = useState('');
  const [overrideReason, setOverrideReason] = useState('');
  const [deviceAlerts, setDeviceAlerts] = useState([]);
  const [userSearch, setUserSearch] = useState('');
  const [userFilterDept, setUserFilterDept] = useState('');
  const [userFilterRole, setUserFilterRole] = useState('');
  const [userFilterDevice, setUserFilterDevice] = useState('');
  const [unreadAlerts, setUnreadAlerts] = useState(0);
  const [mapLocation, setMapLocation] = useState({ lat: '', lng: '', radius: 150 });
  const [currentFilters, setCurrentFilters] = useState({});
  const [resetPwValue, setResetPwValue] = useState('');
  const [resetPwConfirm, setResetPwConfirm] = useState('');
  const location = useLocation();
  const tab = new URLSearchParams(location.search).get('tab') || 'dashboard';
  const [records, setRecords] = useState([]);
  const [users, setUsers] = useState([]);
  const [geofences, setGeofences] = useState([]);
  const [msg, setMsg] = useState({ type: '', text: '' });
  const [loading, setLoading] = useState(true);
  const [openUserDialog, setOpenUserDialog] = useState(false);
  const [newUser, setNewUser] = useState({
  username: '', email: '', password: '',
  first_name: '', last_name: '', role: 'employee',
  department: '', state_of_assignment: ''
  });
  const [geoForm, setGeoForm] = useState({
    name: 'Main Office', latitude: '', longitude: '', radius_meters: 200
  });

  useEffect(() => {
    fetchAll();
  }, []);

  const handleToggleGeofence = async (id, name, currentStatus) => {
    const action = currentStatus ? 'deactivate' : 'activate';
    if (!window.confirm(`${action} geofence "${name}"?`)) return;
    try {
      await api.post(`/geofence/${id}/toggle/`);
      setMsg({ type: 'success', text: `Geofence "${name}" ${action}d.` });
      fetchAll();
    } catch {
      setMsg({ type: 'error', text: 'Failed to update geofence.' });
    }
  };

  const handleBulkUpload = async () => {
  if (!bulkFile) return;
  setBulkLoading(true);
  try {
    const formData = new FormData();
    formData.append('file', bulkFile);
    const { data } = await api.post('/users/bulk-create/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    setBulkResult(data);
    fetchAll();
  } catch (err) {
    setMsg({ type: 'error', text: err.response?.data?.error || 'Bulk upload failed.' });
    setBulkUploadDialog(false);
  } finally {
    setBulkLoading(false);
  }
};

  const getFilteredUsers = () => {
  let result = [...users];

  if (userSearch.trim()) {
    const q = userSearch.toLowerCase();
    result = result.filter(u =>
      u.first_name?.toLowerCase().includes(q) ||
      u.last_name?.toLowerCase().includes(q) ||
      u.username?.toLowerCase().includes(q) ||
      u.email?.toLowerCase().includes(q) ||
      u.department?.toLowerCase().includes(q)
    );
  }

  if (userFilterDept) result = result.filter(u => u.department === userFilterDept);
  if (userFilterRole) result = result.filter(u => u.role === userFilterRole);
  if (userFilterDevice === 'bound') result = result.filter(u => u.device_id);
  if (userFilterDevice === 'unbound') result = result.filter(u => !u.device_id);
  // if (userFilterDevice === 'active') result = result.filter(u => !u.is_blocked);
  //if (userFilterDevice === 'blocked') result = result.filter(u => u.is_blocked);
  
  return result;
};

const clearUserFilters = () => {
  setUserSearch('');
  setUserFilterDept('');
  setUserFilterRole('');
  setUserFilterDevice('');
};

const openOverrideDialog = (user) => {
  setOverrideUser(user);
  setOverrideDate(new Date().toISOString().split('T')[0]);
  setOverrideReason('');
  setOverrideDialog(true);
};

const handleGrantOverride = async () => {
  try {
    await api.post('/attendance/override/', {
      user_id: overrideUser.id,
      date: overrideDate,
      reason: overrideReason,
    });
    setMsg({ type: 'success', text: `Clock-in override granted for ${overrideUser.username} on ${overrideDate}.` });
    setOverrideDialog(false);
  } catch {
    setMsg({ type: 'error', text: 'Failed to grant override.' });
  }
};

const hasActiveUserFilters = userSearch || userFilterDept || userFilterRole || userFilterDevice;

const handleSetActiveGeofence = async (id, name) => {
  if (!window.confirm(`Set "${name}" as the active geofence? All other geofences will be deactivated.`)) return;
  try {
    await api.post(`/geofence/${id}/set-active/`);
    setMsg({ type: 'success', text: `"${name}" is now the active geofence.` });
    fetchAll();
  } catch {
    setMsg({ type: 'error', text: 'Failed to set active geofence.' });
  }
};


const handleDeleteGeofence = async (id, name) => {
  if (!window.confirm(`Permanently delete geofence "${name}"? This cannot be undone.`)) return;
  try {
    await api.delete(`/geofence/${id}/`);
    setMsg({ type: 'success', text: `Geofence "${name}" deleted.` });
    fetchAll();
  } catch {
    setMsg({ type: 'error', text: 'Failed to delete geofence.' });
  }
};

  const fetchAll = async () => {
  setLoading(true);
  try {
    const [recRes, usrRes, geoRes, alertRes, earlyRes, stateRes] = await Promise.all([
      api.get('/attendance/all/'),
      api.get('/users/'),
      api.get('/geofence/'),
      api.get('/alerts/devices/'),
      api.get('/attendance/early-clockout/'),
      api.get('/geofence/state-mapping/'),
    ]);
    setRecords(Array.isArray(recRes.data) ? recRes.data : recRes.data.results || []);
    setUsers(Array.isArray(usrRes.data) ? usrRes.data : usrRes.data.results || []);
    setGeofences(Array.isArray(geoRes.data) ? geoRes.data : geoRes.data.results || []);
    const alerts = Array.isArray(alertRes.data) ? alertRes.data : [];
    setDeviceAlerts(alerts);
    setUnreadAlerts(alerts.filter(a => !a.is_read).length);
    setEarlyClockouts(Array.isArray(earlyRes.data) ? earlyRes.data : []);
    setStateMappings(Array.isArray(stateRes.data) ? stateRes.data : []);
  } finally {
    setLoading(false);
  }
};

const handleSaveStateMapping = async () => {
  if (!stateForm.state) {
    setMsg({ type: 'error', text: 'Please select a state.' });
    return;
  }
  try {
    await api.post('/geofence/state-mapping/', stateForm);
    setMsg({ type: 'success', text: `Geofence assigned to ${stateForm.state}.` });
    setStateForm({ state: '', geofence_id: '' });
    fetchAll();
  } catch {
    setMsg({ type: 'error', text: 'Failed to save state mapping.' });
  }
};

const markAllAlertsRead = async () => {
  try {
    await api.post('/alerts/devices/read-all/');
    setUnreadAlerts(0);
    setDeviceAlerts(prev => prev.map(a => ({ ...a, is_read: true })));
  } catch {
    setMsg({ type: 'error', text: 'Failed to mark alerts as read.' });
  }
};

const handleEarlyClockoutAction = async (recordId, action) => {
  try {
    await api.post(`/attendance/early-clockout/${recordId}/action/`, { action });
    setMsg({
      type: 'success',
      text: action === 'approve' ? 'Early clock-out approved.' : 'Early clock-out rejected.'
    });
    // Remove immediately from state
    setEarlyClockouts(prev => prev.filter(r => r.id !== recordId));
  } catch {
    setMsg({ type: 'error', text: 'Action failed. Please try again.' });
  }
};

  const handleAdminFilter = async (params) => {
  try {
    setLoading(true);
    setCurrentFilters(params);
    const query = new URLSearchParams(params).toString();
    const { data } = await api.get(`/attendance/all/${query ? '?' + query : ''}`);
    setRecords(Array.isArray(data) ? data : data.results || []);
  } catch (err) {
    setMsg({ type: 'error', text: 'Failed to apply filters. Please try again.' });
  } finally {
    setLoading(false);
  }
};

  const handleExport = async (format, exportAll) => {
  try {
    const query = new URLSearchParams(currentFilters).toString();
    const allParam = exportAll ? 'all=true' : '';
    const params = [query, allParam].filter(Boolean).join('&');
    const url = `/attendance/export/${format}/${params ? '?' + params : ''}`;
    const filename = `attendance_${exportAll ? 'all' : 'filtered'}_${new Date().toISOString().split('T')[0]}.${format === 'excel' ? 'xlsx' : 'csv'}`;
    await downloadFile(url, filename);
  } catch {
    setMsg({ type: 'error', text: 'Export failed. Please try again.' });
  }
};

  const createUser = async () => {
  try {
    await api.post('/auth/register/', newUser);
    setMsg({ type: 'success', text: `User "${newUser.username}" created successfully.` });
    setOpenUserDialog(false);
    setNewUser({
      username: '', email: '', password: '',
      first_name: '', last_name: '', role: 'employee',
      department: '', state_of_assignment: ''
    });
    fetchAll();
  } catch (err) {
    const errData = err.response?.data;
    if (errData && typeof errData === 'object') {
      const messages = Object.entries(errData)
        .map(([field, msgs]) => `${field}: ${Array.isArray(msgs) ? msgs.join(' ') : msgs}`)
        .join(' | ');
      setMsg({ type: 'error', text: messages });
    } else {
      setMsg({ type: 'error', text: 'Failed to create user.' });
    }
  }
  };

  const resetDevice = async (userId, username) => {
    if (!window.confirm(`Reset device binding for ${username}?`)) return;
    try {
      await api.post(`/users/${userId}/reset-device/`);
      setMsg({ type: 'success', text: `Device reset for ${username}.` });
      fetchAll();
    } catch {
      setMsg({ type: 'error', text: 'Device reset failed.' });
    }
  };

  const openEditDialog = (u) => {
  setEditUser(u);
  setEditForm({
    first_name: u.first_name || '',
    last_name: u.last_name || '',
    email: u.email || '',
    phone: u.phone || '',
    department: u.department || '',
    state_of_assignment: u.state_of_assignment || '',
    role: u.role || 'employee',
  });
  setEditDialog(true);
};

const handleEditUser = async () => {
  try {
    await api.put(`/users/${editUser.id}/`, editForm);
    setMsg({ type: 'success', text: `${editUser.username} updated successfully.` });
    setEditDialog(false);
    fetchAll();
  } catch (err) {
    setMsg({ type: 'error', text: err.response?.data?.error || 'Update failed.' });
  }
};

const handleBlockUser = async (userId, username, isBlocked) => {
  const action = isBlocked ? 'unblock' : 'block';
  if (!window.confirm(`${action} ${username}?`)) return;
  try {
    await api.post(`/users/${userId}/block/`);
    setMsg({
      type: 'success',
      text: `${username} has been ${isBlocked ? 'unblocked' : 'blocked'}.`
    });
    fetchAll();
  } catch (err) {
    setMsg({ type: 'error', text: err.response?.data?.error || 'Action failed.' });
  }
};

const handleDeleteUser = async (userId, username) => {
  if (!window.confirm(
    `Permanently delete ${username}?\n\nThis will also delete all their attendance records and cannot be undone.`
  )) return;
  try {
    await api.delete(`/users/${userId}/delete/`);
    setMsg({ type: 'success', text: `${username} has been deleted.` });
    fetchAll();
  } catch (err) {
    setMsg({ type: 'error', text: err.response?.data?.error || 'Delete failed.' });
  }
};

  const handleMapLocationSet = ({ lat, lng, radius }) => {
    setMapLocation({ lat, lng, radius: radius || mapLocation.radius });
    setGeoForm((prev) => ({
      ...prev,
      latitude: lat,
      longitude: lng,
      radius_meters: radius || prev.radius_meters,
    }));
  };

  const saveGeofence = async () => {
    try {
      await api.post('/geofence/', geoForm);
      setMsg({ type: 'success', text: 'Geofence saved successfully.' });
      fetchAll();
    } catch {
      setMsg({ type: 'error', text: 'Failed to save geofence.' });
    }
  };

  const openResetPassword = (user) => {
  setResetPwUser(user);
  setResetPwValue('');
  setResetPwConfirm('');
  setResetPwDialog(true);
};

const handleResetPassword = async () => {
  if (resetPwValue.length < 8) {
    setMsg({ type: 'error', text: 'Password must be at least 8 characters.' });
    return;
  }
  if (resetPwValue !== resetPwConfirm) {
    setMsg({ type: 'error', text: 'Passwords do not match.' });
    return;
  }
  try {
    await api.post(`/users/${resetPwUser.id}/reset-password/`, {
      new_password: resetPwValue,
    });
    setMsg({ type: 'success', text: `Password reset successfully for ${resetPwUser.username}.` });
    setResetPwDialog(false);
  } catch (err) {
    setMsg({ type: 'error', text: err.response?.data?.error || 'Password reset failed.' });
  }
};

  const activeNow = records.filter(r => r.status === 'active').length;
  const presentToday = records.filter(r =>
    new Date(r.clock_in).toDateString() === new Date().toDateString()
  ).length;

  const today = new Date().toLocaleDateString('en-GB', {
    weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
  });

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', background: '#f4f6f4', overflowX: 'hidden' }}>
    <AnnouncementOverlay />
    <Sidebar />
    <Box sx={{
  ml: isMobile ? 0 : `${SIDEBAR_WIDTH}px`,
  p: isMobile ? 2 : 3,
  pt: isMobile ? 7 : 3,
  minHeight: '100vh',
  flex: 1,
  minWidth: 0,
  overflowX: 'hidden',
}}>

        {/* Header */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="h5" sx={{ fontWeight: 500 }}>
            {tab === 'attendance' ? 'All Attendance'
              : tab === 'users' ? 'Manage Users'
              : tab === 'geofence' ? 'Geofence Settings'
              : tab === 'reports' ? 'Reports'
              : 'Admin Dashboard'}
          </Typography>
          <Typography sx={{ color: '#888', fontSize: 13, mt: 0.5 }}>{today}</Typography>
        </Box>

        {msg.text && (
          <Alert severity={msg.type} sx={{ mb: 2, borderRadius: 2 }} onClose={() => setMsg({ type: '', text: '' })}>
            {msg.text}
          </Alert>
        )}

        {/* Dashboard tab */}
        {tab === 'dashboard' && (
          <>
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'repeat(2, 1fr)', sm: 'repeat(2, 1fr)', md: 'repeat(5, 1fr)' }, gap: 2, mb: 3 }}>
  {[
    { label: 'Total employees', value: users.length, color: '#1a4d2e' },
    { label: 'Present today', value: presentToday, color: '#1a4d2e' },
    { label: 'Clocked in now', value: activeNow, color: '#2d7a4f' },
    { label: 'Bounded devices', value: users.filter(u => u.device_id).length, color: '#0c447c' },
    { label: 'Geofences active', value: geofences.filter(g => g.is_active).length, color: '#854f0b' },
  ].map(({ label, value, color }) => (
    <Card key={label}>
      <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
        <Typography sx={{ fontSize: 11, color: '#888', mb: 0.5, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
          {label}
        </Typography>
        <Typography sx={{ fontSize: 24, fontWeight: 500, color }}>
          {value}
        </Typography>
      </CardContent>
    </Card>
  ))}
</Box>


            {/* Device registration notification */}
{unreadAlerts > 0 && (
  <Card sx={{ mb: 3, border: '0.5px solid #d0e8d0', background: '#f0f8f0' }}>
    <Box sx={{
      px: 2.5, py: 1.5,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <PhoneAndroidIcon sx={{ fontSize: 16, color: '#1a4d2e' }} />
        <Typography sx={{ fontSize: 13, fontWeight: 500, color: '#1a4d2e' }}>
          {unreadAlerts} new device registration{unreadAlerts !== 1 ? 's' : ''}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Button
          size="small"
          sx={{ fontSize: 12, color: '#2d7a4f' }}
          onClick={markAllAlertsRead}
        >
          Mark read
        </Button>
        <Button
          size="small"
          variant="outlined"
          sx={{ fontSize: 12, borderColor: '#2d7a4f', color: '#1a4d2e', borderRadius: 2 }}
          onClick={() => window.location.href = '/devices'}
        >
          View all →
        </Button>
      </Box>
    </Box>
  </Card>
)}

{/* Early clock-out pending approvals */}
{earlyClockouts.length > 0 && (
  <Card sx={{ mb: 3 }}>
    <Box sx={{ px: 2.5, py: 1.5, borderBottom: '0.5px solid #e8ede8', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <WarningAmberIcon sx={{ fontSize: 16, color: '#854f0b' }} />
        <Typography sx={{ fontSize: 14, fontWeight: 500 }}>Early clock-out requests</Typography>
        <Box sx={{ background: '#faeeda', color: '#633806', fontSize: 11, fontWeight: 500, borderRadius: 10, px: 1, py: 0.25 }}>
          {earlyClockouts.length} pending
        </Box>
      </Box>
    </Box>
    <Box sx={{ overflowX: 'auto' }}>
    <Table size="small" sx={{ minWidth: 600 }}>
      <TableHead>
        <TableRow>
          <TableCell>Employee</TableCell>
          <TableCell>Date</TableCell>
          <TableCell>Clock out time</TableCell>
          <TableCell>Reason</TableCell>
          <TableCell>Actions</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {earlyClockouts.map((r) => (
          <TableRow key={r.id} sx={{ '&:last-child td': { border: 0 } }}>
            <TableCell sx={{ fontWeight: 500 }}>
              {r.user_detail?.first_name} {r.user_detail?.last_name}
            </TableCell>
            <TableCell>{new Date(r.clock_out).toLocaleDateString()}</TableCell>
            <TableCell>{new Date(r.clock_out).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</TableCell>
            <TableCell sx={{ maxWidth: 200 }}>
              <Typography sx={{ fontSize: 12, color: '#555' }}>{r.early_clockout_reason}</Typography>
            </TableCell>
            <TableCell>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Button
                  size="small" variant="contained"
                  sx={{ fontSize: 11, py: 0.25, borderRadius: 1.5, background: '#1a4d2e', '&:hover': { background: '#2d7a4f' } }}
                  onClick={() => handleEarlyClockoutAction(r.id, 'approve')}
                >
                  Approve
                </Button>
                <Button
                  size="small" variant="outlined" color="error"
                  sx={{ fontSize: 11, py: 0.25, borderRadius: 1.5 }}
                  onClick={() => handleEarlyClockoutAction(r.id, 'reject')}
                >
                  Reject
                </Button>
              </Box>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
    </Box>
  </Card>
)}

            {/* Recent attendance */}
            <Card>
              <Box sx={{ px: 2.5, py: 1.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '0.5px solid #e8ede8' }}>
                <Typography sx={{ fontSize: 14, fontWeight: 500 }}>Today's attendance</Typography>
                <Typography
                  sx={{ fontSize: 12, color: '#2d7a4f', cursor: 'pointer' }}
                  onClick={() => window.location.href = '/admin?tab=attendance'}
                >
                  View all →
                </Typography>
              </Box>
              <AdminAttendanceTable records={records.slice(0, 8)} onResetDevice={resetDevice} showUser />
            </Card>
          </>
        )}

        {/* Attendance tab */}
        {tab === 'attendance' && (
          <Card>
            <Box sx={{
              px: 2.5, py: 1.5,
              borderBottom: '0.5px solid #e8ede8',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <Typography sx={{ fontSize: 14, fontWeight: 500 }}>All attendance records</Typography>
              <Typography sx={{ fontSize: 12, color: '#888' }}>{records.length} record{records.length !== 1 ? 's' : ''}</Typography>
          </Box>
          <AttendanceFilter
            onFilter={handleAdminFilter}
            onExport={handleExport}
            showAdminFilters={true}
            users={users}
          />
          {loading ? (
            <Box sx={{ p: 4, textAlign: 'center' }}>
              <CircularProgress size={28} sx={{ color: '#1a4d2e' }} />
            </Box>
           ) : (
             <AdminAttendanceTable records={records} showUser />
           )}
        </Card>
      )}

        {/* Users tab */}
        {tab === 'users' && (
  <>
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2, gap: 1 }}>
  <Button
    variant="outlined"
    onClick={() => { setBulkUploadDialog(true); setBulkResult(null); setBulkFile(null); }}
    sx={{ borderColor: '#1a4d2e', color: '#1a4d2e' }}
  >
    Bulk Upload
  </Button>
  <Button
    variant="contained"
    startIcon={<AddIcon />}
    onClick={() => setOpenUserDialog(true)}
    sx={{ background: '#1a4d2e', '&:hover': { background: '#2d7a4f' } }}
  >
    Add Employee
  </Button>
</Box>
    

    <Card>
      {/* Filter bar */}
      <Box sx={{ p: 2, background: '#fafcfa', borderBottom: '0.5px solid #e8ede8' }}>
        <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', alignItems: 'flex-end' }}>
          <TextField
            placeholder="Search by name, username, email..."
            size="small"
            value={userSearch}
            onChange={(e) => setUserSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ fontSize: 18, color: '#aaa' }} />
                </InputAdornment>
              ),
            }}
            sx={{ minWidth: 240 }}
          />
          <FormControl size="small" sx={{ minWidth: 180 }}>
            <InputLabel>Department</InputLabel>
            <Select
              label="Department"
              value={userFilterDept}
              onChange={(e) => setUserFilterDept(e.target.value)}
            >
              <MenuItem value="">All departments</MenuItem>
              {DEPARTMENTS.map((d) => (
                <MenuItem key={d} value={d}>{d}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl size="small" sx={{ minWidth: 140 }}>
            <InputLabel>Role</InputLabel>
            <Select
              label="Role"
              value={userFilterRole}
              onChange={(e) => setUserFilterRole(e.target.value)}
            >
              <MenuItem value="">All roles</MenuItem>
              <MenuItem value="employee">Employee</MenuItem>
              <MenuItem value="department_head">Dept. Head</MenuItem>
              <MenuItem value="admin">Admin</MenuItem>
            </Select>
          </FormControl>
          <FormControl size="small" sx={{ minWidth: 140 }}>
            <InputLabel>Device</InputLabel>
            <Select
              label="Device"
              value={userFilterDevice}
              onChange={(e) => setUserFilterDevice(e.target.value)}
            >
              <MenuItem value="">All</MenuItem>
              <MenuItem value="bound">Bound</MenuItem>
              <MenuItem value="unbound">Unbound</MenuItem>
            </Select>
          </FormControl>
          
          {hasActiveUserFilters && (
            <Button size="small" onClick={clearUserFilters} sx={{ color: '#888' }}>
              Clear filters
            </Button>
          )}
        </Box>
        {hasActiveUserFilters && (
          <Typography sx={{ fontSize: 12, color: '#888', mt: 1 }}>
            Showing {getFilteredUsers().length} of {users.length} users
          </Typography>
        )}
      </Box>

      {/* Users table */}
<Box sx={{ overflowX: 'auto' }}>
<Table size="small" sx={{ minWidth: 700 }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: 48 }}></TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Username</TableCell>
            <TableCell>Phone</TableCell>
            <TableCell>Department</TableCell>
            <TableCell>State</TableCell>
            <TableCell>Role</TableCell>
            <TableCell>Device</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {getFilteredUsers().map((u) => (
            <TableRow key={u.id} sx={{ '&:last-child td': { border: 0 } }}>
              <TableCell>
                {u.profile_photo_url ? (
                  <Box
                    component="img"
                    src={u.profile_photo_url}
                    alt={u.username}
                    sx={{
                      width: 34, height: 34, borderRadius: '50%',
                      objectFit: 'cover', border: '2px solid #eaf3de', display: 'block',
                    }}
                  />
                ) : (
                  <Box sx={{
                    width: 34, height: 34, borderRadius: '50%',
                    background: '#eaf3de', display: 'flex',
                    alignItems: 'center', justifyContent: 'center',
                    fontSize: 12, fontWeight: 500, color: '#1a4d2e', flexShrink: 0,
                  }}>
                    {`${u.first_name?.[0] || ''}${u.last_name?.[0] || ''}`.toUpperCase() || u.username?.[0]?.toUpperCase()}
                  </Box>
                )}
              </TableCell>
              <TableCell>
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    <Typography sx={{ fontSize: 13, fontWeight: 500 }}>
      {u.first_name} {u.last_name}
    </Typography>
    {u.is_blocked && (
      <Chip
        label="Blocked"
        size="small"
        sx={{ background: '#fcebeb', color: '#791f1f', fontSize: 10 }}
      />
    )}
  </Box>
</TableCell>
              <TableCell sx={{ color: '#888' }}>@{u.username}</TableCell>
              <TableCell>{u.phone || '—'}</TableCell>
              <TableCell>{u.department || '—'}</TableCell>
              <TableCell>{u.state_of_assignment || '—'}</TableCell>
              <TableCell>
                <Chip
                  label={u.role === 'department_head' ? 'Dept. Head' : u.role}
                  size="small"
                  sx={{
                    background: u.role === 'admin' ? '#e6f1fb' : u.role === 'department_head' ? '#faeeda' : '#eaf3de',
                    color: u.role === 'admin' ? '#0c447c' : u.role === 'department_head' ? '#633806' : '#27500a',
                    fontSize: 11,
                  }}
                />
              </TableCell>
              <TableCell>
                <Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <PhoneAndroidIcon sx={{ fontSize: 14, color: u.device_id ? '#2d7a4f' : '#ccc' }} />
                    <Typography sx={{ fontSize: 12, color: u.device_id ? '#2d7a4f' : '#aaa' }}>
                      {u.device_id ? 'Bound' : 'Unbound'}
                    </Typography>
                  </Box>
                  {u.device_name && (
                    <Typography sx={{ fontSize: 11, color: '#aaa', mt: 0.25 }}>{u.device_name}</Typography>
                  )}
                  {u.device_registered_at && (
                    <Typography sx={{ fontSize: 11, color: '#aaa' }}>
                      {new Date(u.device_registered_at).toLocaleDateString()}
                    </Typography>
                  )}
                </Box>
              </TableCell>
              <TableCell>
  <IconButton
    size="small"
    onClick={(e) => setActionAnchor({ anchor: e.currentTarget, user: u })}
  >
    <MoreVertIcon />
  </IconButton>

  <Menu
    anchorEl={actionAnchor?.anchor}
    open={Boolean(actionAnchor && actionAnchor.user?.id === u.id)}
    onClose={() => setActionAnchor(null)}
  >
    <MenuItem onClick={() => { openEditDialog(u); setActionAnchor(null); }}>
      Edit
    </MenuItem>

    {u.device_id && (
      <MenuItem onClick={() => { resetDevice(u.id, u.username); setActionAnchor(null); }}>
        Reset device
      </MenuItem>
    )}

    <MenuItem onClick={() => { openResetPassword(u); setActionAnchor(null); }}>
      Reset password
    </MenuItem>

    <MenuItem onClick={() => { openOverrideDialog(u); setActionAnchor(null); }}>
      Clock‑in override
    </MenuItem>

    <MenuItem onClick={() => { handleBlockUser(u.id, u.username, u.is_blocked); setActionAnchor(null); }}>
      {u.is_blocked ? 'Unblock' : 'Block'}
    </MenuItem>

    <MenuItem
      sx={{ color: 'error.main' }}
      onClick={() => { handleDeleteUser(u.id, u.username); setActionAnchor(null); }}
    >
      Delete
    </MenuItem>
  </Menu>
</TableCell>
            </TableRow>
          ))}
          {getFilteredUsers().length === 0 && (
            <TableRow>
              <TableCell colSpan={9} align="center" sx={{ py: 4, color: '#aaa', fontSize: 13 }}>
                {hasActiveUserFilters ? 'No users match your filters' : 'No users found'}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      </Box>
    </Card>

            {/* Create user dialog */}
            <Dialog open={openUserDialog} onClose={() => setOpenUserDialog(false)} maxWidth="xs" fullWidth fullScreen={isMobile}>
              <DialogTitle sx={{ fontWeight: 500, pb: 1 }}>Add New Employee</DialogTitle>
              <DialogContent>
                {[
                  { field: 'first_name', label: 'First Name' },
                  { field: 'last_name', label: 'Last Name' },
                  { field: 'username', label: 'Username' },
                  { field: 'email', label: 'Email' },
                  { field: 'password', label: 'Password', type: 'password' },
                ].map(({ field, label, type }) => (
                  <TextField
                    key={field} label={label} fullWidth margin="dense"
                    type={type || 'text'}
                    value={newUser[field]}
                    onChange={(e) => setNewUser({ ...newUser, [field]: e.target.value })}
                  />
                ))}
                <FormControl fullWidth margin="dense">
                  <InputLabel>Department</InputLabel>
                  <Select
                    label="Department"
                    value={newUser.department}
                    onChange={(e) => setNewUser({ ...newUser, department: e.target.value })}
                  >
                    <MenuItem value="">— Select Department —</MenuItem>
                    {DEPARTMENTS.map((d) => (
                      <MenuItem key={d} value={d}>{d}</MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <InputLabel>State of assignment</InputLabel>
                  <Select
                    label="State of assignment"
                    value={newUser.state_of_assignment || ''}
                    onChange={(e) => setNewUser({ ...newUser, state_of_assignment: e.target.value })}
                  >
                    <MenuItem value="">— Select state —</MenuItem>
                    {STATES.map((s) => (
                      <MenuItem key={s} value={s}>{s}</MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <InputLabel>Role</InputLabel>
                  <Select
                    label="Role"
                    value={newUser.role}
                    onChange={(e) => setNewUser({ ...newUser, role: e.target.value })}
                  >
                    <MenuItem value="employee">Employee</MenuItem>
                    <MenuItem value="department_head">Department Head</MenuItem>
                    <MenuItem value="admin">Admin</MenuItem>
                  </Select>
                </FormControl>
              </DialogContent>
              <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={() => setOpenUserDialog(false)} sx={{ color: '#888' }}>Cancel</Button>
                <Button
                  variant="contained"
                  onClick={createUser}
                  sx={{ background: '#1a4d2e', '&:hover': { background: '#2d7a4f' } }}
                >
                  Create Employee
                </Button>
              </DialogActions>
            </Dialog>
          </>
        )}

        {/* Geofence tab */}
        {tab === 'geofence' && (
  <Box sx={{ display: 'grid', gridTemplateColumns: '1fr', gap: 3 }}>

    {/* Map picker card */}
    <Card>
      <Box sx={{ px: 2.5, py: 1.5, borderBottom: '0.5px solid #e8ede8', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography sx={{ fontSize: 14, fontWeight: 500 }}>Set geofence location</Typography>
        <Typography sx={{ fontSize: 12, color: '#888' }}>Search or click on map</Typography>
      </Box>
      <Box sx={{ p: 2.5 }}>
        <GeofenceMap
          onLocationSet={handleMapLocationSet}
          initialLat={geofences[0]?.latitude}
          initialLng={geofences[0]?.longitude}
          initialRadius={geofences[0]?.radius_meters}
        />
      </Box>
    </Card>

    {/* Save form + active geofences side by side */}
    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 3 }}>

      {/* Save form */}
      <Card>
        <Box sx={{ px: 2.5, py: 1.5, borderBottom: '0.5px solid #e8ede8' }}>
          <Typography sx={{ fontSize: 14, fontWeight: 500 }}>Save geofence</Typography>
        </Box>
        <Box sx={{ p: 2.5 }}>
          <TextField
            label="Location name"
            fullWidth
            margin="dense"
            value={geoForm.name}
            onChange={(e) => setGeoForm({ ...geoForm, name: e.target.value })}
          />
          <TextField
            label="Latitude"
            fullWidth
            margin="dense"
            type="number"
            value={geoForm.latitude}
            onChange={(e) => setGeoForm({ ...geoForm, latitude: e.target.value })}
            helperText="Auto-filled when you click the map"
          />
          <TextField
            label="Longitude"
            fullWidth
            margin="dense"
            type="number"
            value={geoForm.longitude}
            onChange={(e) => setGeoForm({ ...geoForm, longitude: e.target.value })}
            helperText="Auto-filled when you click the map"
          />
          <TextField
            label="Radius (metres)"
            fullWidth
            margin="dense"
            type="number"
            value={geoForm.radius_meters}
            onChange={(e) => setGeoForm({ ...geoForm, radius_meters: e.target.value })}
            helperText="Adjust the circle on the map to visualize"
          />
          <Button
            variant="contained"
            fullWidth
            sx={{ mt: 2, background: '#1a4d2e', '&:hover': { background: '#2d7a4f' } }}
            onClick={saveGeofence}
            startIcon={<LocationOnIcon />}
            disabled={!geoForm.latitude || !geoForm.longitude}
          >
            Save Geofence
          </Button>
        </Box>
      </Card>

      {/* Active geofences */}
      <Card>
        <Box sx={{ px: 2.5, py: 1.5, borderBottom: '0.5px solid #e8ede8' }}>
          <Typography sx={{ fontSize: 14, fontWeight: 500 }}>Active geofences</Typography>
        </Box>
        <Box sx={{ p: 2 }}>
          {geofences.length === 0 && (
            <Typography sx={{ fontSize: 13, color: '#aaa', py: 2, textAlign: 'center' }}>
              No geofences configured yet
            </Typography>
          )}
          {geofences.map((g) => (
  <Box key={g.id} sx={{
    p: 2, borderRadius: 2,
    border: `0.5px solid ${g.is_active ? '#2d7a4f' : '#e0e8e0'}`,
    mb: 1.5,
    background: g.is_active ? '#f0f8f0' : '#fafafa',
  }}>
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
      <Typography sx={{ fontWeight: 500, fontSize: 14 }}>{g.name}</Typography>
      <Chip
        label={g.is_active ? 'Active' : 'Inactive'}
        size="small"
        sx={{
          background: g.is_active ? '#eaf3de' : '#f1efe8',
          color: g.is_active ? '#27500a' : '#888',
          fontSize: 11,
        }}
      />
    </Box>
    <Typography sx={{ fontSize: 12, color: '#888' }}>
      Lat: {g.latitude} | Lng: {g.longitude}
    </Typography>
    <Typography sx={{ fontSize: 12, color: '#888', mb: 1.5 }}>
      Radius: {g.radius_meters} metres
    </Typography>
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
      {!g.is_active && (
        <Button
          size="small"
          variant="contained"
          sx={{
            fontSize: 11, py: 0.25, borderRadius: 1.5,
            background: '#1a4d2e',
            '&:hover': { background: '#2d7a4f' }
          }}
          onClick={() => handleSetActiveGeofence(g.id, g.name)}
        >
          Set as active
        </Button>
      )}
      {g.is_active && (
        <Button
          size="small"
          variant="outlined"
          sx={{
            fontSize: 11, py: 0.25, borderRadius: 1.5,
            borderColor: '#888', color: '#888',
          }}
          onClick={() => handleToggleGeofence(g.id, g.name, g.is_active)}
        >
          Deactivate
        </Button>
      )}
      <Button
        size="small"
        variant="outlined"
        color="error"
        sx={{ fontSize: 11, py: 0.25, borderRadius: 1.5 }}
        onClick={() => handleDeleteGeofence(g.id, g.name)}
      >
        Delete
      </Button>
    </Box>
  </Box>
))}
        </Box>
      </Card>
    </Box>

    {/* State to geofence mapping */}
<Card sx={{ mt: 3 }}>
  <Box sx={{ px: 2.5, py: 1.5, borderBottom: '0.5px solid #e8ede8' }}>
    <Typography sx={{ fontSize: 14, fontWeight: 500 }}>State of assignment — geofence mapping</Typography>
  </Box>
  <Box sx={{ p: 2.5, display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 3 }}>

    {/* Assignment form */}
    <Box>
      <Typography sx={{ fontSize: 13, color: '#888', mb: 2 }}>
        Assign a geofence to each state. Employees in that state will use the assigned geofence when clocking in.
      </Typography>
      <FormControl fullWidth margin="dense">
        <InputLabel>State</InputLabel>
        <Select
          label="State"
          value={stateForm.state}
          onChange={(e) => setStateForm({ ...stateForm, state: e.target.value })}
        >
          <MenuItem value="">— Select state —</MenuItem>
          {STATES.map((s) => (
            <MenuItem key={s} value={s}>{s}</MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl fullWidth margin="dense">
        <InputLabel>Geofence</InputLabel>
        <Select
          label="Geofence"
          value={stateForm.geofence_id}
          onChange={(e) => setStateForm({ ...stateForm, geofence_id: e.target.value })}
        >
          <MenuItem value="">— Select geofence —</MenuItem>
          {geofences.map((g) => (
            <MenuItem key={g.id} value={g.id}>{g.name}</MenuItem>
          ))}
        </Select>
      </FormControl>
      <Button
        variant="contained"
        fullWidth
        sx={{ mt: 1.5, background: '#1a4d2e', '&:hover': { background: '#2d7a4f' } }}
        onClick={handleSaveStateMapping}
        disabled={!stateForm.state}
      >
        Save mapping
      </Button>
    </Box>

    {/* Current mappings table */}
    <Box>
      <Typography sx={{ fontSize: 13, fontWeight: 500, mb: 1.5 }}>
        Current mappings ({stateMappings.length})
      </Typography>
      <Box sx={{ overflowX: 'auto' }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>State</TableCell>
              <TableCell>Geofence</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {stateMappings.map((m) => (
              <TableRow key={m.id} sx={{ '&:last-child td': { border: 0 } }}>
                <TableCell sx={{ fontWeight: 500 }}>{m.state}</TableCell>
                <TableCell>
                  {m.geofence_name ? (
                    <Chip
                      label={m.geofence_name}
                      size="small"
                      sx={{ background: '#eaf3de', color: '#27500a', fontSize: 11 }}
                    />
                  ) : (
                    <Typography sx={{ fontSize: 12, color: '#aaa' }}>No geofence</Typography>
                  )}
                </TableCell>
              </TableRow>
            ))}
            {stateMappings.length === 0 && (
              <TableRow>
                <TableCell colSpan={2} align="center" sx={{ py: 3, color: '#aaa', fontSize: 13 }}>
                  No mappings configured yet
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Box>
    </Box>
  </Box>
</Card>
  </Box>
)}
        {/* Reset password dialog */}
<Dialog open={resetPwDialog} onClose={() => setResetPwDialog(false)} maxWidth="xs" fullWidth fullScreen={isMobile}>
  <DialogTitle sx={{ fontWeight: 500, pb: 1 }}>
    Reset password for @{resetPwUser?.username}
  </DialogTitle>
  <DialogContent>
    <Typography sx={{ fontSize: 13, color: '#888', mb: 2 }}>
      Set a new password for {resetPwUser?.first_name} {resetPwUser?.last_name}.
      They should change it after logging in.
    </Typography>
    <TextField
      label="New password"
      type="password"
      fullWidth
      margin="dense"
      value={resetPwValue}
      onChange={(e) => setResetPwValue(e.target.value)}
    />
    <TextField
      label="Confirm new password"
      type="password"
      fullWidth
      margin="dense"
      value={resetPwConfirm}
      onChange={(e) => setResetPwConfirm(e.target.value)}
    />
  </DialogContent>
  <DialogActions sx={{ px: 3, pb: 2 }}>
    <Button onClick={() => setResetPwDialog(false)} sx={{ color: '#888' }}>
      Cancel
    </Button>
    <Button
      variant="contained"
      onClick={handleResetPassword}
      sx={{ background: '#1a4d2e', '&:hover': { background: '#2d7a4f' } }}
    >
      Reset password
    </Button>
  </DialogActions>
</Dialog>

{/* Bulk upload dialog */}
<Dialog open={bulkUploadDialog} onClose={() => setBulkUploadDialog(false)} maxWidth="sm" fullWidth fullScreen={isMobile}>
  <DialogTitle sx={{ fontWeight: 500 }}>Bulk Create Users from Excel</DialogTitle>
  <DialogContent>
    {!bulkResult ? (
      <Box>
        <Alert severity="info" sx={{ mb: 2, borderRadius: 2, fontSize: 13 }}>
          Upload an Excel file (.xlsx) with these columns:<br />
          <strong>username, email, password, first_name, last_name</strong> (required)<br />
          <em>role, department, state_of_assignment, phone</em> (optional)
          <Box sx={{ mt: 1 }}>
  <Button
    size="small"
    variant="text"
    sx={{ color: '#1a4d2e', fontSize: 12, p: 0 }}
    onClick={() => {
      const headers = ['username', 'email', 'password', 'first_name', 'last_name', 'role', 'department', 'state_of_assignment', 'phone'];
      const example = ['jdoe', 'jdoe@example.com', 'Password123', 'John', 'Doe', 'employee', 'HR&A', 'FCT', '08012345678'];
      const csvContent = [headers.join(','), example.join(',')].join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'bulk_users_template.csv';
      link.click();
    }}
  >
    Download template
  </Button>
</Box>
        </Alert>
        <Button
          variant="outlined"
          component="label"
          fullWidth
          sx={{ borderColor: '#1a4d2e', color: '#1a4d2e', py: 2, borderStyle: 'dashed', borderRadius: 2 }}
        >
          {bulkFile ? bulkFile.name : 'Click to select Excel file (.xlsx)'}
          <input
            type="file"
            hidden
            accept=".xlsx,.xls"
            onChange={(e) => setBulkFile(e.target.files[0])}
          />
        </Button>
        {bulkFile && (
          <Typography sx={{ fontSize: 12, color: '#888', mt: 1 }}>
            {bulkFile.name} — {(bulkFile.size / 1024).toFixed(1)} KB
          </Typography>
        )}
      </Box>
    ) : (
      <Box>
        <Alert severity={bulkResult.errors?.length > 0 ? 'warning' : 'success'} sx={{ mb: 2, borderRadius: 2 }}>
          {bulkResult.message}
        </Alert>
        {bulkResult.created?.length > 0 && (
          <Box sx={{ mb: 1.5 }}>
            <Typography sx={{ fontSize: 13, fontWeight: 500, color: '#1a4d2e', mb: 0.5 }}>
              Created ({bulkResult.created.length}):
            </Typography>
            <Typography sx={{ fontSize: 12, color: '#555' }}>
              {bulkResult.created.join(', ')}
            </Typography>
          </Box>
        )}
        {bulkResult.skipped?.length > 0 && (
          <Box sx={{ mb: 1.5 }}>
            <Typography sx={{ fontSize: 13, fontWeight: 500, color: '#854f0b', mb: 0.5 }}>
              Skipped ({bulkResult.skipped.length}):
            </Typography>
            <Typography sx={{ fontSize: 12, color: '#555' }}>
              {bulkResult.skipped.join(', ')}
            </Typography>
          </Box>
        )}
        {bulkResult.errors?.length > 0 && (
          <Box>
            <Typography sx={{ fontSize: 13, fontWeight: 500, color: '#791f1f', mb: 0.5 }}>
              Errors ({bulkResult.errors.length}):
            </Typography>
            {bulkResult.errors.map((e, i) => (
              <Typography key={i} sx={{ fontSize: 12, color: '#791f1f' }}>• {e}</Typography>
            ))}
          </Box>
        )}
      </Box>
    )}
  </DialogContent>
  <DialogActions sx={{ px: 3, pb: 2 }}>
    <Button onClick={() => setBulkUploadDialog(false)} sx={{ color: '#888' }}>
      {bulkResult ? 'Close' : 'Cancel'}
    </Button>
    {!bulkResult && (
      <Button
        variant="contained"
        onClick={handleBulkUpload}
        disabled={!bulkFile || bulkLoading}
        sx={{ background: '#1a4d2e', '&:hover': { background: '#2d7a4f' } }}
      >
        {bulkLoading ? <CircularProgress size={18} color="inherit" /> : 'Upload & Create'}
      </Button>
    )}
  </DialogActions>
</Dialog>

{/* Clock-in override dialog */}
{/* Clock-in override dialog */}
<Dialog open={overrideDialog} onClose={() => setOverrideDialog(false)} maxWidth="xs" fullWidth fullScreen={isMobile}>
  <DialogTitle sx={{ fontWeight: 500 }}>
    Grant clock-in override
  </DialogTitle>
  <DialogContent>
    <Typography sx={{ fontSize: 13, color: '#666', mb: 2 }}>
      This allows <strong>{overrideUser?.username}</strong> to clock in after 4:00 PM on the selected date.
    </Typography>
    <TextField
      label="Date" type="date" fullWidth margin="dense"
      value={overrideDate}
      onChange={(e) => setOverrideDate(e.target.value)}
      InputLabelProps={{ shrink: true }}
    />
    <TextField
      label="Reason (optional)" fullWidth margin="dense" multiline rows={2}
      value={overrideReason}
      onChange={(e) => setOverrideReason(e.target.value)}
    />
  </DialogContent>
  <DialogActions sx={{ px: 3, pb: 2 }}>
    <Button onClick={() => setOverrideDialog(false)} sx={{ color: '#888' }}>Cancel</Button>
    <Button
      variant="contained"
      onClick={handleGrantOverride}
      sx={{ background: '#1a4d2e', '&:hover': { background: '#2d7a4f' } }}
    >
      Grant override
    </Button>
  </DialogActions>
</Dialog>

{/* Edit user dialog */}
<Dialog open={editDialog} onClose={() => setEditDialog(false)} maxWidth="sm" fullWidth fullScreen={isMobile}>
  <DialogTitle sx={{ fontWeight: 500, pb: 1 }}>
    Edit user — @{editUser?.username}
  </DialogTitle>
  <DialogContent>
    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1.5, mt: 0.5 }}>
      <TextField
        label="First name" fullWidth margin="dense"
        value={editForm.first_name || ''}
        onChange={(e) => setEditForm({ ...editForm, first_name: e.target.value })}
      />
      <TextField
        label="Last name" fullWidth margin="dense"
        value={editForm.last_name || ''}
        onChange={(e) => setEditForm({ ...editForm, last_name: e.target.value })}
      />
    </Box>
    <TextField
      label="Email" fullWidth margin="dense" type="email"
      value={editForm.email || ''}
      onChange={(e) => setEditForm({ ...editForm, email: e.target.value })}
    />
    <TextField
      label="Phone" fullWidth margin="dense"
      value={editForm.phone || ''}
      onChange={(e) => setEditForm({ ...editForm, phone: e.target.value })}
    />
    <FormControl fullWidth margin="dense">
      <InputLabel>Department</InputLabel>
      <Select
        label="Department"
        value={editForm.department || ''}
        onChange={(e) => setEditForm({ ...editForm, department: e.target.value })}
      >
        <MenuItem value="">— Select department —</MenuItem>
        {DEPARTMENTS.map((d) => (
          <MenuItem key={d} value={d}>{d}</MenuItem>
        ))}
      </Select>
    </FormControl>
    <FormControl fullWidth margin="dense">
      <InputLabel>State of assignment</InputLabel>
      <Select
        label="State of assignment"
        value={editForm.state_of_assignment || ''}
        onChange={(e) => setEditForm({ ...editForm, state_of_assignment: e.target.value })}
      >
        <MenuItem value="">— Select state —</MenuItem>
        {STATES.map((s) => (
          <MenuItem key={s} value={s}>{s}</MenuItem>
        ))}
      </Select>
    </FormControl>
    <FormControl fullWidth margin="dense">
      <InputLabel>Role</InputLabel>
      <Select
        label="Role"
        value={editForm.role || 'employee'}
        onChange={(e) => setEditForm({ ...editForm, role: e.target.value })}
      >
        <MenuItem value="employee">Employee</MenuItem>
        <MenuItem value="department_head">Department Head</MenuItem>
        <MenuItem value="admin">Admin</MenuItem>
      </Select>
    </FormControl>
  </DialogContent>
  <DialogActions sx={{ px: 3, pb: 2 }}>
    <Button onClick={() => setEditDialog(false)} sx={{ color: '#888' }}>Cancel</Button>
    <Button
      variant="contained"
      onClick={handleEditUser}
      sx={{ background: '#1a4d2e', '&:hover': { background: '#2d7a4f' } }}
    >
      Save changes
    </Button>
  </DialogActions>
</Dialog>
      </Box>
    </Box>
  );
}
      
function AdminAttendanceTable({ records, showUser }) {
  return (
    <Box sx={{ overflowX: 'auto' }}>
  <Table size="small" sx={{ minWidth: 700 }}>
      <TableHead>
        <TableRow>
          {showUser && <TableCell>Employee</TableCell>}
          {showUser && <TableCell>Department</TableCell>}
          <TableCell>Date</TableCell>
          <TableCell>Clock In</TableCell>
          <TableCell>Clock Out</TableCell>
          <TableCell>Duration</TableCell>
          <TableCell>Status</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {records.map((r) => (
          <TableRow key={r.id} sx={{ '&:last-child td': { border: 0 } }}>
            {showUser && <TableCell sx={{ fontWeight: 500 }}>{r.user_detail?.first_name} {r.user_detail?.last_name}</TableCell>}
            {showUser && <TableCell sx={{ color: '#888', fontSize: 12 }}>{r.user_detail?.department || '—'}</TableCell>}
            <TableCell>{new Date(r.clock_in).toLocaleDateString()}</TableCell>
            <TableCell>{new Date(r.clock_in).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</TableCell>
            <TableCell>{r.clock_out ? new Date(r.clock_out).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '—'}</TableCell>
            <TableCell>{r.duration_display || '—'}</TableCell>
            <TableCell>
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
    <Chip
      label={r.status}
      size="small"
      sx={{
        background: r.status === 'active' ? '#eaf3de' : '#f1efe8',
        color: r.status === 'active' ? '#27500a' : '#444',
        fontSize: 11,
      }}
    />
    {r.is_late && (
      <Chip
        label={`Late ${r.lateness_minutes}m`}
        size="small"
        sx={{ background: '#faeeda', color: '#633806', fontSize: 11 }}
      />
    )}
    {r.is_early_clockout && (
      <Chip
        label="Early out"
        size="small"
        sx={{ background: '#fcebeb', color: '#791f1f', fontSize: 11 }}
      />
    )}
  </Box>
</TableCell>
          </TableRow>
        ))}
        {records.length === 0 && (
          <TableRow>
            <TableCell colSpan={8} align="center" sx={{ py: 4, color: '#aaa', fontSize: 13 }}>
              No attendance records found
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
</Box>
  );
  
}